<template>
  <v-card flat color="grey lighten-4" rounded="lg">
    <v-card-title class="subtitle-2 font-weight-bold pb-2"
      >Contato {{ numContato }}</v-card-title
    >
    <v-card-text>      
      <v-row>
        <v-col cols="3">
          <v-text-field
            label="DDD"
            v-mask="'##'"
            v-model="ddd"
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="9">
          <v-text-field
            label="Telefone"
            v-model="telefone"
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <modal-edit-contato
            :dadosContato="{
              numcontato: numContato,
              ddd: ddd,
              telefone: telefone,
            }"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import ModalEditContato from "./ModalEditContato.vue";
export default {
  components: { ModalEditContato },
  props: {
    numContato: Number,
  },
  computed: mapState("atualizacaoCadastral", ["dadosCadastrais"]),
  data: () => ({
    ddd: 0,
    telefone: 0,
  }),
  mounted() {    
    if (this.numContato == 1) {
      this.ddd = this.dadosCadastrais.ddd1;
      this.telefone = this.dadosCadastrais.telefone1;
    } else {
      this.ddd = this.dadosCadastrais.ddd2;
      this.telefone = this.dadosCadastrais.telefone2;
    }
  },
};
</script>

<style>
</style>